import posthog from "posthog-js";

type Tracking = {
  triggerEvent: (
    event?: string,
    extraOptions?: Record<string, unknown>
  ) => void;
};

export const tracking: Tracking = {
  triggerEvent: (event, extraOptions = {}): void => {
    if (!posthog.config) {
      return;
    }

    if (event) {
      posthog.capture(event, extraOptions);
    }
  },
};
